import React from "react"

//interfaces
import { ITermsAndConditionsModal,} from "../../../interfaces/modals";

//components
import { BasicButton, ThriveModal } from "thrive-components";
import { TermsAndConditions } from "./terms-and-conditions";

//styles
import './terms-and-conditions-modal.scss';



const TermsAndConditionsModal = ({showModal, onHideModal, onAgreeClick} : ITermsAndConditionsModal) => {
    return (
        <ThriveModal 
            showModal={showModal} 
            canEscapeClose
            className="terms-and-conditions-modal"
            headerContent={"Terms & Conditions"} 
            bodyContent={TermsAndConditions} 
            footerContent={<>
                <BasicButton    
                    className="i-agree-button"
                    content={"I Agree"}
                    ariaLabel={"I Agree"}
                    onButtonClick={onAgreeClick}
                />
            </>

            } 
            onCloseClick={onHideModal}            
        />
    );
}

export default TermsAndConditionsModal